import {
  Component,
  OnInit,
  ElementRef,
  Input
} from "@angular/core";
import { DialogService } from "../dialog";
import { DialogComponent } from "../dialog/dialog.component";
import { DataService } from "../../services/data.service";
import { MainService } from "../../services/main.service";
import { InProductsService } from "../../services/inventory/in-products.service";
import { ExcelService } from './../../../shared/services/inventory/excel.service';
export interface ConfirmModel22 {
  title: string;
  data: any;
}

@Component({
  selector: 'app-transactionhistory',
  templateUrl: './transactionhistory.component.html',
  styleUrls: ['./transactionhistory.component.css']
})
export class TransactionhistoryComponent extends DialogComponent<ConfirmModel22, boolean> implements ConfirmModel22, OnInit {
  title: string;
  message: string;
  loading: boolean = false;
  loadingtrans: boolean = false;
  result: any = { item: [], result: false };;
  rtnData: any;
  data: any;
  selectedRow: number = -1;
  sliceStrat: number = 0;
  sliceEnd: number = 15;
  Unit: string = "";
  locationlist: any = []
  Type: any = []
  Historytype: number
  transactiondata: any = []
  salesdata: any = []
  fromDate: Date = new Date();
  toDate: Date = new Date();
  Cols: any;
  TransCols: any;
  scrollable: boolean = false;
  isLoaded: boolean = false;
  private el: ElementRef;
  @Input() onReturn: string;
  fullData: any;
  totalData: number = 0
  totAmount: number = 0.00;
  totQty: number = 0;

  constructor(dialogService: DialogService, private ds: DataService, private ms: MainService, private pds: InProductsService, private excelservice: ExcelService) {
    super(dialogService);
    this.fullData = this.data;
  }
  getPage: any = { page: 1, limit: 25, start: 10, searchText: "" };
  getPageTrans: any = { page: 1, limit: 10, start: 10, searchText: "" };
  config: any = {
    offset: 1,
    range: 3,
    colunms: [],
    data: [],
    Action: false,
    Actions: {}
  };
  limit: number = 25;
  requesteddata: any = {
    Location: this.ds.Settings.LocationId,
    ItemmasterId: 0,
    Fromdate: this.fromDate,
    Todate: this.toDate,
    RequestedList: {
      Start: 0,
      FiterText: "",
      Limit: this.limit,
      ItemTypeId: this.ds.Settings.ItemTypeId,
      CAType: this.ds.Settings.CAType
    }
  }
  requesteddatatransaction: any = {
    LocationId: this.ds.Settings.LocationId,
    ItemmasterId: 0,
    Fromdate: this.fromDate,
    Todate: this.toDate,
    RequestedList: {
      Start: 0,
      FiterText: "",
      Limit: this.limit,
      ItemTypeId: this.ds.Settings.ItemTypeId,
      CAType: this.ds.Settings.CAType
    }
  }
  ngOnInit() {
    this.fromDate = new Date
    this.toDate = new Date
    this.isLoaded = true;
    this.getType()
    this.getLocationList()
    this.fullData = this.data;
    if (!this.fullData) {
      this.close();
    } else {
      // this.loading = true;
      this.isLoaded = true;
      this.loadingtrans = true
    }
    // this.getSaleshistory()
  }
  getType() {
    this.Type = [];
    this.Type.push({ Id: 1, Name: 1 + " - " + "Sales History" }, { Id: 2, Name: 2 + " - " + "Transaction History" });
    this.Historytype = 1
  }
  getLocationList() {
    var FilterData: any = {
      CompanyId: this.ds.Settings.CompanyId,
      RequestedList: {
        Start: 0,
        FiterText: "",
        Limit: this.ds.Settings.MaxLimit,
        ItemTypeId: this.ds.Settings.ItemTypeId,
        CAType: this.ds.Settings.CAType
      }
    }
    this.ms.GetLocationByCompany(FilterData).subscribe(res => {
      if (res.Success) {
        for (let i of res.data) {
          this.locationlist.push({ LocationId: i.Id })
        }
      }
    });
  }
  getTransactionHistory() {
    this.isLoaded = false;
    this.loadingtrans = true;
    this.requesteddatatransaction.LocationId = this.ds.Settings.LocationId
    this.requesteddatatransaction.ItemmasterId = this.fullData.Id
    this.requesteddatatransaction.Fromdate = this.fromDate
    this.requesteddatatransaction.Todate = this.toDate
    this.requesteddatatransaction.RequestedList.FiterText = this.getPage.searchText
    this.pds.getTransactionHistory(this.requesteddatatransaction).subscribe(res => {
      if (res.Success) {
        this.transactiondata = res
        this.totalData = res.total;
        this.loadTransactionTable();
        this.loadingtrans = false;
      }
      else {
        this.transactiondata = [];
        this.totalData = 0;
        this.loadTransactionTable();
        this.loadingtrans = false;
      }
      this.isLoaded = true;
    }
    )
  }

  getSaleshistory() {
    this.isLoaded = false;
    this.loading = true;
    this.requesteddata.Fromdate = this.fromDate
    this.requesteddata.ToDate = this.toDate
    this.requesteddata.Location = this.ds.Settings.LocationId
    this.requesteddata.RequestedList.FiterText = this.getPage.searchText
    this.requesteddata.ItemmasterId = this.fullData.Id
    this.pds.getSalesHistory(this.requesteddata).subscribe(res => {
      if (res.Success) {
        this.salesdata = res.data;
        this.totalData = res.total.InvCount;
        this.totAmount = res.total.Total;
        this.totQty=res.total.TotalQty;
        this.LoadTable();
        this.loading = false;
      }
      else {
        this.salesdata = [];
        this.totalData = 0;
        this.totAmount = 0.00;
        this.totQty=0;
        this.LoadTable();
        this.loading = false;
      }
      this.isLoaded = true;
    }
    )
  }
  onSearchSales(event) {
    if (event.keyCode == 13 || event.which == 13) {
      var value = event.target.value
      this.getPage.searchText = value
      if (this.Historytype == 1) {
        this.getSaleshistory()
      } else if (this.Historytype == 2) {
        this.getTransactionHistory()
      }
      // this.getSaleshistory()
    }
  }
  typeChange(e) {
    this.Historytype = e.Id
    if (this.Historytype == 1) {
      this.LoadTable()
    }
    else if (this.Historytype == 2) {
      this.loadTransactionTable()
    }
  }
  exportAsXLSX(): void {
    if (this.Historytype == 1) {
      this.excelservice.exportAsExcelFile(this.salesdata, 'Sales History');
    }
    else if (this.Historytype == 2) {
      this.excelservice.exportAsExcelFile(this.transactiondata, 'Transaction History');
    }
  }
  LoadTable() {
    this.config.offset = 1;
    this.config.range = 1;
    this.config.colunms = [
      { Name: "Invno", width: "70px", Heading: "Inv No.", Id: 1, t: 'text', f: 'input' },
      { Name: "InvDate", width: "70px", Heading: "InvDate", Id: 2, t: 'date', f: 'input' },
      { Name: "InvTime", width: "70px", Heading: "Inv Time", Id: 3, t: 'text', f: 'input' },
      { Name: "Barcode", width: "70px", Heading: "Barcode", Id: 4, t: 'text', f: 'input' },
      { Name: "Itemname", width: "70px", Heading: "Itemname", Id: 5, t: 'text', f: 'input' },
      { Name: "Unit", width: "70px", Heading: "Unit", Id: 6, t: 'text', f: 'input' },
      { Name: "Salesqty", width: "70px", Heading: "Sales Qty", Id: 7, t: 'qtytext', f: 'input' },
      { Name: "QtyPrice", width: "70px", Heading: "Qty/Price", Id: 8, t: 'qtytext', f: 'input' },
      { Name: "Rate", width: "70px", Heading: "Rate", Id: 9, t: 'decimal', f: 'decimal' },
      { Name: "Discount", width: "70px", Heading: "Discount", Id: 10, t: 'decimal', f: 'decimal' },
      { Name: "TotalAmount", width: "70px", Heading: "Total", Id: 11, t: 'decimal', f: 'decimal' },
    ];
    this.config.data = this.salesdata;
  }
  loadTransactionTable() {
    this.config.offset = 1;
    this.config.range = 1;
    this.config.colunms = [
      { Name: "Type", width: "50px", Heading: "Type", Id: 1, t: 'text', f: 'input' },
      { Name: "Location", width: "50px", Heading: "Location", Id: 2, t: 'text', f: 'input' },
      { Name: "Date", width: "50px", Heading: "Date", Id: 3, t: 'date', f: 'input' },
      { Name: "Party", width: "50px", Heading: "Party", Id: 4, t: 'text', f: 'input' },
      { Name: "Barcode", width: "50px", Heading: "Barcode", Id: 5, t: 'text', f: 'input' },
      { Name: "Itemname", width: "50px", Heading: "Itemname", Id: 6, t: 'text', f: 'input' },
      { Name: "Unit", width: "50px", Heading: "Unit", Id: 7, t: 'text', f: 'input' },
      { Name: "InQuantity", width: "50px", Heading: "InQuantity", Id: 8, t: 'decimal', f: 'decimal' },
      { Name: "InRate", width: "50px", Heading: "InRate", Id: 9, t: 'decimal', f: 'decimal' },
      { Name: "InAmount", width: "50px", Heading: "InAmount", Id: 10, t: 'decimal', f: 'decimal' },
      { Name: "OutQuantity", width: "50px", Heading: "OutQuantity", Id: 11, t: 'decimal', f: 'decimal' },
      { Name: "OutRate", width: "50px", Heading: "OutRate", Id: 12, t: 'decimal', f: 'decimal' },
      { Name: "OutAmount", width: "50px", Heading: "OutAmount", Id: 13, t: 'decimal', f: 'decimal' },
      { Name: "Note", width: "50px", Heading: "Note", Id: 14, t: 'text', f: 'input' },
      { Name: "RefNo", width: "50px", Heading: "RefNo", Id: 15, t: 'text', f: 'input' },
      { Name: "wac", width: "50px", Heading: "W.Avg Cost", Id: 16, t: 'decimal', f: 'decimal' },
    ];
    this.config.data = this.transactiondata.data;
  }
  pagechange(v: any) {
    if (this.Historytype == 1) {
      this.getPage = v;
      this.requesteddata.RequestedList.Start = v.start;
      this.requesteddata.RequestedList.limit = v.limit;
      this.limit = v.limit;
      this.getSaleshistory();
    }
    else if (this.Historytype == 2) {
      this.getPage = v;
      this.requesteddatatransaction.RequestedList.Start = v.start;
      this.requesteddatatransaction.RequestedList.limit = v.limit;
      this.limit = v.limit;
      this.getTransactionHistory();
    }
  }
  loadCarsLazy(event: any) {
    // console.log(event)
    if (this.Historytype == 1) {
      this.requesteddata.RequestedList.Start = event.first;
      this.requesteddata.RequestedList.limit = event.rows;
      this.limit = event.rows;
      this.getSaleshistory();
    } else if (this.Historytype == 2) {
      this.requesteddatatransaction.RequestedList.Start = event.first;
      this.requesteddatatransaction.RequestedList.limit = event.rows;
      this.limit = event.rows;
      this.getTransactionHistory();
    }
  }
  confirm(item) {
    this.result = { item: item, result: true };
    this.close();
  }
  // setClickedRow(e) {
  //   this.selectedRow = e;
  //   document.getElementById("focus").focus();
  // }
  // NextBut() {
  //   if (!this.NexbutEnable()) {
  //     this.fullData = this.data;
  //     this.sliceEnd = Number(this.sliceEnd) + 15
  //     this.selectedRow = 0
  //   }
  // }
  // PreBut() {
  //   if (!this.PrebutEnable()) {
  //     this.fullData = this.data;
  //     this.sliceEnd = Number(this.sliceEnd) - 15
  //     this.selectedRow = 0
  //   }
  // }
  // NexbutEnable(): boolean {
  //   return this.fullData.data.legth > this.sliceEnd
  // }
  // PrebutEnable(): boolean {
  //   return this.sliceEnd < 16
  // }

  // scroll(event: KeyboardEvent) {
  //   //up 38 down 40
  //   event.preventDefault();
  //   if (event.keyCode === 40) {
  //     if (this.selectedRow > 13) {
  //       this.NextBut();
  //     } else {
  //       this.selectedRow++;
  //     }
  //   } else if (event.keyCode === 38) {
  //     if (this.selectedRow < 1) {
  //       this.PreBut();
  //     } else {
  //       this.selectedRow--;
  //     }
  //   } else if (event.keyCode === 13) {
  //     this.selecedItem();
  //   }
  //   else return;
  // }
  // selecedItem() {
  //   var abc = document.getElementsByClassName("selectedItesmsaerch786")[0].getElementsByClassName("bkd")[0].innerHTML;
  //   var bcd = this.fullData.data.find(x => x.Code == abc);
  //   this.confirm(bcd);
  // }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/transactionhistory/transactionhistory.component.ts